import { createContext, useCallback, useContext, useEffect } from "react";
import { useDispatch } from "react-redux";
import * as commonActions from "../store/common/common-actions";
import { useKeycloak } from "@react-keycloak/web";
import { useTranslation } from "react-i18next";

export interface CommonActionContextInterface {}

export const CommonActionContext = createContext<CommonActionContextInterface>(
  {}
);

export const useCommonActionContext = () => useContext(CommonActionContext);

export const CommonActionProvider: React.FC = ({ children }) => {
  const dispatch = useDispatch();
  const { keycloak } = useKeycloak();
  const { i18n } = useTranslation();

  const fetchAll = useCallback(() => {
    dispatch(commonActions.fetchExperienceTime());
    dispatch(commonActions.fetchDiversity());
    dispatch(commonActions.fetchProficiency());
    dispatch(commonActions.fetchHireType());
    dispatch(commonActions.fetchDegree());
    dispatch(commonActions.fetchProfessionalMoment());
    dispatch(commonActions.fetchAllSkills());
  }, [dispatch]);

  useEffect(() => {
    if (keycloak.token && i18n.language) {
      fetchAll();
    }
  }, [fetchAll, keycloak.token, i18n.language]);

  return (
    <CommonActionContext.Provider value={{}}>
      {children}
    </CommonActionContext.Provider>
  );
};
